import { Component } from "../lib/component.ts";
import { enableDragScroll } from "../lib/drag-scroll.ts";
import { createScrollbar } from "../lib/faux-scrollbar.ts";

interface ProductMediaRefs {
  scrollbar?: HTMLElement;

  thumb?: HTMLElement;
}

/**
 * Horizontal scrolling gallery that converts vertical wheel scrolling to
 * horizontal scrolling on hover-capable devices, and supports drag-to-scroll.
 */
class ProductMedia extends Component<ProductMediaRefs> {
  connectedCallback(): void {
    super.connectedCallback();

    const { scrollbar, thumb } = this.refs;
    if (scrollbar && thumb) {
      createScrollbar(this, scrollbar, thumb, this.signal);
    }

    if (!window.matchMedia("(hover: hover)").matches) return;

    this.addEventListener("wheel", this.#handleWheel, {
      signal: this.signal,
      passive: false,
    });

    enableDragScroll(this, this.signal);
  }

  #handleWheel = (event: WheelEvent): void => {
    // Skip line/page modes (notched scroll wheels) where discrete input feels awkward
    if (event.deltaMode !== 0) return;
    if (event.deltaY === 0) return;
    if (document.documentElement.hasAttribute("data-scroll-locked")) return;

    const { scrollLeft, scrollWidth, clientWidth } = this;
    const atStart = Math.floor(scrollLeft) <= 0;
    const atEnd = Math.ceil(scrollLeft) + clientWidth >= scrollWidth;
    const viewportAtTop = window.scrollY <= 0;

    if (event.deltaY > 0 && atEnd) return;
    if (event.deltaY < 0 && !viewportAtTop) return;
    if (event.deltaY < 0 && atStart) return;

    event.preventDefault();
    this.scrollLeft += event.deltaY;
  };
}

if (!customElements.get("product-media")) {
  customElements.define("product-media", ProductMedia);
}
